<div class="tile-heading bg">
    <span msTextAutoScroll class="title">{{ title }}</span>
</div>
